import { render, staticRenderFns } from "./FairBlackjack.vue?vue&type=template&id=33f551de&scoped=true"
import script from "./FairBlackjack.vue?vue&type=script&lang=js"
export * from "./FairBlackjack.vue?vue&type=script&lang=js"
import style0 from "./FairBlackjack.vue?vue&type=style&index=0&id=33f551de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f551de",
  null
  
)

export default component.exports